module.exports = __webpack_public_path__ + "img/idea_reality@2x.0dd0b37.jpg";